import * as FileSystem from "expo-file-system";
import * as MediaLibrary from "expo-media-library";
import * as Permissions from "expo-permissions";
import flash from "./flash";

const saveFileAsync = async (name, document, fileName) => {
  try {
    let file = await FileSystem.downloadAsync(
      document,
      FileSystem.documentDirectory + fileName + ".png"
    );
    const { status, permissions } = await Permissions.askAsync(
      Permissions.MEDIA_LIBRARY
    );
    if (
      status === "granted" &&
      permissions.mediaLibrary.accessPrivileges !== "limited"
    ) {
      const asset = await MediaLibrary.createAssetAsync(file.uri);
      let album = await MediaLibrary.getAlbumAsync(name);
      if (album)
        await MediaLibrary.addAssetsToAlbumAsync([asset], album, false);
      else await MediaLibrary.createAlbumAsync(name, asset);

      await Promise.all([asset, album]);
      flash(
        `File has been saved. Please go to "Photos" to view the downloaded file.`,
        "success",
        5000
      );
      return true;
    }
    return false;
  } catch (error) {
    flash(`An error occurred. Please try again.`, "danger");
  }
};

export default saveFileAsync;
